<template>
  <div class="select">
    <van-field
      readonly
      clickable
      :label="obj.label"
      :value="text"
      :placeholder="obj.placeholder"
      right-icon="arrow"
      @click="showTermPicker = true"
    />
    <van-popup v-model="showTermPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="obj.values"
        @cancel="showTermPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
     <div class="line">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: ['obj'],
  data() {
    return {
      showTermPicker: false,
      text: '',
    };
  },
  watch: {
    value: {
    },
  },
  mounted() {
    // 初始化默认值
    this.onConfirm(this.obj.values[0]);
  },
  methods: {
    onConfirm(values) {
      this.$emit('monitors', this.obj, values);
      this.text = values.text;
      this.showTermPicker = false;
    },
  },
};
</script>
<style scoped>
.select{
  position: relative;
  border: 0;
}
.select >>> .van-field__label {
  color: rgba(56, 56, 56, 1);
}
.select >>> .van-field__control {
  text-align: right;
  color: rgba(128, 128, 128, 1)
}
.line::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  /* border-bottom: 1px solid #dddee1; */
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.van-picker__cancel,
.van-picker__confirm {
  color: #ff6538;
}
</style>
